import React from "react";
import { useAtom } from "jotai";
import { themeAtom, saveTheme } from "../_helpers/theme";
import { Button, Dropdown } from "antd";
import {
    SunOutlined,
    MoonOutlined,
    BgColorsOutlined,
    CheckOutlined,
    HighlightOutlined,
} from "@ant-design/icons";

const THEME_OPTIONS = [
    { key: "default", label: "Default", icon: <HighlightOutlined /> },
    { key: "light", label: "Light", icon: <SunOutlined /> },
    { key: "dark", label: "Dark", icon: <MoonOutlined /> },
    { key: "ocean", label: "Ocean", icon: <BgColorsOutlined /> },
];

function ThemeSelector({ children }) {
    const [currentTheme, setTheme] = useAtom(themeAtom);

    const handleSelect = ({ key }) => {
        setTheme(key);
        saveTheme(key);
    };

    const items = THEME_OPTIONS.map((opt) => ({
        key: opt.key,
        label: opt.label,
        icon: currentTheme === opt.key ? <CheckOutlined /> : opt.icon,
    }));

    return (
        <Dropdown
            menu={{
                items,
                onClick: handleSelect,
                selectedKeys: [currentTheme],
            }}
            trigger={["click"]}
            placement="bottomRight"
        >
            {children ?? <Button icon={<BgColorsOutlined />} size="small" />}
        </Dropdown>
    );
}

export default ThemeSelector;
